import { render } from "./CheckIcon.vue?vue&type=template&id=3b4b5870&scoped=true"
import script from "./CheckIcon.vue?vue&type=script&lang=js"
export * from "./CheckIcon.vue?vue&type=script&lang=js"

import "./CheckIcon.vue?vue&type=style&index=0&id=3b4b5870&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b4b5870"]])

export default __exports__